import { createContext } from "react";
const Multipage_OurTeamContext = createContext({});
export default Multipage_OurTeamContext;
